import styled, { css } from 'styled-components';

export const Element = styled.div`
  ${({ theme, ...props }) => {
    return css`
      background: ${theme.color.neutral_100};
      padding: ${theme.spacing.sm} ${theme.spacing.base};
      border-radius: ${theme.radius.sm};
      @media screen and (min-width: ${theme.breakpoint.sm}) {
        margin-bottom: ${theme.spacing.md};
      }

      form {
        display: flex;
        align-items: center;
        justify-content: right;
        gap: 0.5rem;
        label {
          font-weight: bold;
          font-size: ${theme.typography.font_size.text_sm};
        }
        select {
          width: auto;
        }
      }
    `;
  }};
`;
